import { MessageAttachment } from '@crowdex/ui/ai/message';
import type { FilePart } from '@/lib/conversations/message-part/types';

/**
 * The images a turn's tools returned (a screenshot, a generated photo), as a compact strip of
 * thumbnails where those steps ran: seen without opening the steps, each opens full size.
 */
export function ToolImageStrip({ parts }: { parts: readonly FilePart[] }) {
  if (parts.length === 0) return null;
  return (
    <ul aria-label="Images from the steps" className="flex flex-wrap gap-1.5">
      {parts.map((part, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: The same image can come twice; images are positions in the strip.
        <li key={`${part.url.length}-${index}`}>
          <MessageAttachment
            className="size-16"
            data={{ ...part, filename: part.filename || `Image ${index + 1}` }}
          />
        </li>
      ))}
    </ul>
  );
}
